import { defineStore } from 'pinia'
import { authApi } from '../api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
  
  actions: {
    async login(credentials) {
      const response = await authApi.login(credentials)
      this.token = response.token
      this.user = response.user
      localStorage.setItem('token', this.token)
      return response
    },
    
    async logout() {
      // 先尝试调用登出接口（如果失败也不影响）
      try {
        await authApi.logout()
      } catch (error) {
        // 登出接口失败不影响，继续清除本地状态
        console.error('Logout error:', error)
      } finally {
        // 无论登出接口是否成功，都清除本地状态
        this.token = null
        this.user = null
        localStorage.removeItem('token')
      }
    },
    
    async fetchUser() {
      try {
        const response = await authApi.getMe()
        this.user = response.user
        return response
      } catch (error) {
        this.logout()
        throw error
      }
    },
  },
})

